import React from "react";

export const IdBackGizmo = ({
                                stroke = '#ffffff',
                                height = 175,
                                width = 265,
                            }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 265 175" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.1181 1H7.85826C4.09664 1 1.04724 4.0494 1.04724 7.81102V17.3465" stroke="black"
                  strokeWidth="1.3622"/>
            <path d="M20.1181 174H7.85826C4.09664 174 1.04724 170.951 1.04724 167.189V157.654" stroke="black"
                  strokeWidth="1.3622"/>
            <path d="M244.882 1H257.142C260.903 1 263.953 4.0494 263.953 7.81102V17.3465" stroke="black"
                  strokeWidth="1.3622"/>
            <path d="M244.882 174H257.142C260.903 174 263.953 170.951 263.953 167.189V157.654" stroke="black"
                  strokeWidth="1.3622"/>
            <rect x="7.85828" y="7.81104" width="249.283" height="158.016" rx="6.81102" fill="#E4EAFA"/>
            <rect x="17" y="21" width="232" height="15" rx="2.72441" fill="#ADC0F7"/>
            <rect x="17" y="43" width="73" height="15" rx="2.72441" fill="#ADC0F7"/>
            <rect x="95" y="46" width="36.7795" height="5.44882" rx="2.72441" fill="#ADC0F7"/>
            <rect x="184" y="46" width="65.3858" height="5.44882" rx="2.72441" fill="#ADC0F7"/>
            <rect x="26" y="150" width="111.701" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
            <rect x="25.5669" y="128.079" width="205.693" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
            <rect x="25.5669" y="140.339" width="205.693" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
            <rect x="26" y="116" width="38.1417" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
            <rect x="76.4015" y="116" width="38.1417" height="2.72441" rx="1.3622" fill="#ADC0F7"/>
        </svg>

    );
};